interface CDNSettings {
  assetUrl: string
}

declare global {
  interface Window {
    cdnSettings?: CDNSettings
  }
}

export default function cdnAsset(path: string): string {
  const assetUrl = window.cdnSettings?.assetUrl || ""
  return `${assetUrl}/${path.replace(/^\//, "")}`
}
